function AboutPage() {
  return (
    <div className="About">
      <h1>About Lua</h1>
      <a
        href="https://www.producthunt.com/posts/lua?utm_source=badge-top-post-badge&utm_medium=badge&utm_souce=badge-lua"
        target="_blank"
        rel="noreferrer"
      >
        <img
          src="https://api.producthunt.com/widgets/embed-image/v1/top-post-badge.svg?post_id=324967&theme=light&period=daily"
          alt="Lua - No-code token minter for Polygon | Product Hunt"
          style={{ width: "250px", height: "54px", marginBottom: "1em" }}
          width="250"
          height="54"
        />
      </a>
      <div className="description">
        <p>
          {" "}
          Lua is a simple, no-code token minter for{" "}
          <a href="https://polygon.technology/">Polygon</a>. It allows you to
          issue an ERC20 token without the hassle of deploying a smart contract
          manually. Lua is still a very early product, but in the spirit of
          getting feedback quickly, we are opening it up for beta users.
        </p>
        <b>Workflow</b>
        <p>
          Make sure you are connected to the Polygon network, and connect your
          wallet with Lua using Metamask. Define your token's name, symbol, and
          supply.{" "}
        </p>
        <p>
          An ERC20 contract will be deployed to Polygon with the information you
          specified. Add the token to your Metamask wallet, and use the tool to
          send tokens to others.
        </p>
        <p>
          We created Lua because in our own experience building web3 products,
          we've had to do the same token deployment flow over and over again.
          This is a way to abstract it for ourselves, and for more projects that
          need some sort of token issuing. Use it to mint any token -- for your
          community, your project or protocol, or just for fun! A few ideas:
          <ul>
            <li>A token for internal use at your organization or company</li>
            <li>
              A token for your neighborhood or community to reward good behavior
              / give kudos
            </li>
            <li>A personal token to give your friends/family</li>
          </ul>
        </p>
        <b>Contract Verification</b>
        <p>
          Contracts deployed with Lua are verified on Polygonscan See this{" "}
          <a
            href="https://www.youtube.com/watch?v=l-mH7k4XUR8"
            target="_blank"
            rel="noreferrer"
          >
            see walkthrough video
          </a>{" "}
          if you would like to understand the process or do it yourself. Here's
          an{" "}
          <a
            href="https://polygonscan.com/address/0x181277916197ba92e845e70c0f37cbF98C768689#code"
            target="_blank"
            rel="noreferrer"
          >
            example
          </a>{" "}
          of a verified contract generated with Lua by one of our users.
        </p>

        <p>
          Please submit any questions, bugs, or feature requests to{" "}
          <b>hello@lua.cash</b>. We read all messages and will get back to you
          ASAP.
        </p>
      </div>
      <h3>FAQ</h3>
      <div className="description">
        <p style={{ fontWeight: "bold" }}>
          Is there a walkthrough or tutorial?
        </p>
        <p>
          You bet! Check out this{" "}
          <a
            href="https://youtu.be/yvo7jzP75oQ"
            target="_blank"
            rel="noreferrer"
          >
            demo
          </a>
          .
        </p>
        <p style={{ fontWeight: "bold" }}>What does the contract look like?</p>
        <p>
          This is a generic ERC20 contract from{" "}
          <a href="https://docs.openzeppelin.com/contracts/3.x/api/token/erc20#IERC20">
            OpenZeppelin
          </a>
          . ERC20 is a{" "}
          <a href="https://eips.ethereum.org/EIPS/eip-20">standard</a> that
          provides basic functionality of an Ethereum token. It denotes the set
          of features that a token must provide in order to be compliant, and is
          used by the most well-known digital currencies. This includes the
          total supply, the owner's address, etc.
        </p>
        <p>
          See{" "}
          <a
            href="https://gist.github.com/jw122/7401f9a51d93e4b66963ab6f445ec1a8"
            target="_blank"
            rel="noreferrer"
          >
            this gist
          </a>{" "}
          for a flattened contract of Lua's TokenFactory with the ERC20
          interface from OpenZeppelin.
        </p>
        <p style={{ fontWeight: "bold" }}>What's on the roadmap?</p>
        <p>
          We have heard suggestions for enabling quick and easy airdrops
          (airdrops as a service). Or supporting liquidity bootstrapping for a
          newly minted token on a decentralized exchange like Sushiswap (DEX
          listing as a service).
        </p>
        <p>What would you like to see? Let us know!</p>
        <p style={{ fontWeight: "bold" }}>How was it built?</p>
        <p>
          Lua is a React app built with Ethers.js, Hardhat to support smart
          contracts, bootstrap, and deployed with Vercel.
        </p>
        <p style={{ fontWeight: "bold" }}>Why is it called Lua?</p>
        <p>
          Lua means moon in Portuguese. The crypto community often uses the
          phrase "to the moon" to describe a token that is rising significantly,
          and to indicate general bulishness and optimism. We thought it would
          be fitting :)
        </p>
        <p>
          P.S. we are aware that there is also a{" "}
          <a href="https://www.lua.org/">programming language</a> called Lua.
          Nerds seem to like moon analogies!
        </p>
      </div>
    </div>
  );
}

export default AboutPage;
